export function canViewCurrentAnalysisPremium({ userHadPremiumWhenUploaded }) {
  return Boolean(userHadPremiumWhenUploaded);
}

export function canStartNewPremiumAnalysis({ credits }) {
  return Number(credits || 0) > 0;
}

export function getCurrentAnalysisExportState({
  isAuthenticated,
  userHadPremiumWhenUploaded,
  credits,
  canExportPdf,
}) {
  if (!isAuthenticated) {
    return 'loginRequired';
  }

  if (!canViewCurrentAnalysisPremium({ userHadPremiumWhenUploaded })) {
    return canStartNewPremiumAnalysis({ credits })
      ? 'readyToRerun'
      : 'creditsRequired';
  }

  return canExportPdf ? 'available' : 'loading';
}
